module.exports = __webpack_public_path__ + "img/kiosk_logo2.246b713f.jpg";